<template>
  <div class="purchase-container">
    <!-- 账户信息卡片 -->
    <a-card class="content-card flow-card">
      <div class="flow-header">
        <a-icon type="info-circle" class="flow-icon" />
        <div class="flow-title">{{ translate('purchase.accountInfo') }}</div>
      </div>
      <div class="flow-stats">
        <div class="flow-item">
          <span class="flow-label">{{ translate('purchase.currentPlan') }}</span>
          <span class="flow-value">{{ translate('purchase.noPlan') }}</span>
        </div>
        <a-divider style="margin: 12px 0; border-color: rgba(255, 255, 255, 0.2);" />
        <div class="flow-item">
          <span class="flow-label">{{ translate('purchase.perGigabytePrice') }}</span>
          <span class="flow-value">${{ Mkprice }}/GB</span>
        </div>
      </div>
    </a-card>

    <!-- 购买选择卡片 -->
    <a-card class="content-card proxy-result-card highlight-card">
      <div class="card-header">
        <a-icon type="shopping-cart" class="header-icon" />
        <div class="header-title">{{ translate('purchase.whatTypeBroadband') }}</div>
      </div>

      <a-tabs v-model="value" @change="changeTab()" class="custom-tabs">
        <a-tab-pane key="dtzz" :tab="translate('purchase.dynamicResidence')" class="tab-pane">
          <div class="tab-content">
            <div class="section-title">{{ translate('purchase.needOverGB') }}</div>
            <div class="section-desc">{{ translate('purchase.buyPackage') }}</div>
            
            <div class="select-row">
              <div class="select-item">
                <div class="config-item">
                  <span class="config-label">{{ translate('purchase.selectPackage') }}</span>
                  <a-select v-model="selectlevelValue" @change="changepid" class="custom-select">
                    <a-select-option v-for="item in broadList" :value="item.pid" :key="item.pid">
                      ${{ item.money }} - {{ translate('purchase.dynamicResidence') }} - {{ item.flow }}GB ({{ item.discountNum ? translate('purchase.discountPrice') : ''}}{{ item.discountNum ? ': ' : ''}}${{ item.unitPrice }}{{ item.discountNum ? '*' : ''}}{{ item.discountNum || ''}}/1GB)
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>

            <div class="action-bar">
              <a-space class="action-buttons">
                <a-button v-for="item in BtnnameList" :key="item.dictValue" @click="PaymentWays(item)" class="action-btn generate-btn">
                  {{ item.dictLabel }}
                </a-button>
              </a-space>
              <div style="flex: 1;"></div>
            </div>
          </div>
        </a-tab-pane>

        <a-tab-pane key="jtzz" :tab="translate('purchase.staticResidence')" class="tab-pane">
          <div class="tab-content">
            <div class="section-title">{{ translate('purchase.needOverGB') }}</div>
            <div class="section-desc">{{ translate('purchase.buyPackage') }}</div>
            
            <div class="select-row">
              <div class="select-item">
                <div class="config-item">
                  <span class="config-label">{{ translate('purchase.selectPackage') }}</span>
                  <a-select v-model="selectleveljValue" @change="changepid" class="custom-select">
                    <a-select-option v-for="item in broadListj" :value="item.pid" :key="item.pid">
                      ${{ item.money }} - {{ Kdname }} - {{ item.flow }}GB ({{ item.discountNum ? translate('purchase.discountPrice') : ''}}{{ item.discountNum ? ': ' : ''}}${{ item.unitPrice }}{{ item.discountNum ? '*' : ''}}{{ item.discountNum || ''}}/1GB)
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>

            <div class="action-bar">
              <a-space class="action-buttons">
                <a-button v-for="item in BtnnameList" :key="item.dictValue" @click="PaymentWays(item)" class="action-btn generate-btn">
                  {{ item.dictLabel }}
                </a-button>
              </a-space>
              <div style="flex: 1;"></div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-card>

    <!-- 支付弹框 -->
    <a-modal :visible="visiblepay" :width="800" @ok="addflew" @cancel="visiblepay = false"
      :okText="translate('purchase.confirm')" :cancelText="translate('purchase.cancel')"
      class="payment-modal"
    >
      <iframe style="width: 100%;height: 500px;margin-top: 10px;margin-top: -10px;border: none;" :src="payurl"></iframe>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'PurchasePage',
  components: {
  },
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
    Kdname() {
      return this.translate('purchase.staticResidence');
    },
    discount() {
      return this.translate('purchase.discountPrice');
    },
    secondsCom() {
      return this.seconds < 10 ? '0' + this.seconds : this.seconds;
    }
  },
  data() {
      return {
          uid:localStorage.getItem("userId"),
          pid:0,
          dictValueType:'',
          value: 'dtzz',
          Mkprice: 0,
          payurl:'',
          selectlevel: '',
          selectlevelj: '',
          selectlevelValue: null,
          selectleveljValue: null,
          qrCodeUrl: '1111', // 二维码的内容
          imageUrl:'',

          broadList:[],
          broadLists:[],
          broadListj:[],
          broadListy:[],
          formData:{
              host:'',
              port:'',
              username:'',
              password:'',
          },
          dataLoading: false,
          rowKey: 'index',
          tableLayout: 'auto',
          verticalAlign: 'top',
          bordered: true,
          hover: true,
          pagination: {
              defaultPageSize: 10,
              total: 0,
              defaultCurrent: 1,
          },
          data:[
              { "uid":0,"creatTime":11,"flow":'小姜',"flowOverdue1":5,"flowOverdue4":1,"flowOverdue3":1 }
          ],
          IsoCodeList:[],
          BtnnameList:[],
          flow:'', //总流量
          flowoverdue:'', //剩余流量，获取参数总流量减去该参数
          visiblepay: false, //支付弹框
          minutes: 9,
          seconds: 59,
          timer:'',//定时器名称
      };
  },
  mounted(){
      this.getIsoCodeList();
      this.getBtnnameList();
      this.timecalc();
      this.start();
  },
  methods:{
      //登录状态测试
      getLoginStatus(){
      this.$request.get('/ums/isLoginStates').then((res) => {
      if (res.data.code === 5000) {
              this.$router.push('/login')
              window.localStorage.clear();
              this.$message.warning(this.translate('purchase.loginWarning'));
          }
          })
          .catch((e) => {
          console.log(e);
      })
      }, 
      start(){
          this.timer = setInterval(this.getLoginStatus, 10000); // 第一个参数为方法名的时候不要加括号;
      },
      
      //获取宽带类型
      getIsoCodeList() {
      this.$request.get('/package/getlist').then((res) => {
        if (res.data.code === 200) {
              this.broadList = res.data.data.dtzz || [];
              this.broadListj = res.data.data.jtzz || [];
              //判断下拉框是否有值，有的话默认第一个值的pid，没有则不打开弹框
              if(this.value == 'dtzz' && Array.isArray(this.broadList) && this.broadList.length >0){
                  this.pid = this.broadList[0].pid;
              }else if(this.value == 'jtzz' && Array.isArray(this.broadListj) && this.broadListj.length >0){
                  this.pid = this.broadListj[0].pid;
              }else{
                  this.pid = 0;
              }
              //您的每千兆字节价格默认值
              if(Array.isArray(this.broadList) && this.broadList.length >0){
                  this.Mkprice = this.broadList[0].unitPrice
              }else if(Array.isArray(this.broadListj) && this.broadListj.length >0){
                  this.Mkprice = this.broadListj[0].unitPrice
              }else{
                  this.Mkprice = 0;
              }
              //设置下拉框默认值
              if(Array.isArray(this.broadList) && this.broadList.length >0){
                  this.selectlevelValue = this.broadList[0].pid;
              }else{
                  this.selectlevelValue = null;
              }
              if(Array.isArray(this.broadListj) && this.broadListj.length >0){
                  this.selectleveljValue = this.broadListj[0].pid;
              }else{
                  this.selectleveljValue = null;
              }
              this.changeTab();
          }
          })
          .catch((e) => {
          console.log(e);
          })
          .finally(() => {
          });
      },
      //国际化翻译方法
      translate(key) {
        const lang = this.currentLanguage;
        const translations = {
          'purchase.currentPlan': lang === 'zh' ? '您当前计划' : 'Your current plan',
          'purchase.perGigabytePrice': lang === 'zh' ? '您的每千兆字节价格' : 'Your per gigabyte price',
          'purchase.whatTypeBroadband': lang === 'zh' ? '您需要什么类型的宽带？' : 'What type of broadband do you need?',
          'purchase.needOverGB': lang === 'zh' ? '需要超过几GB的带宽？' : 'Need more than a few GB of bandwidth?',
          'purchase.buyPackage': lang === 'zh' ? '以更优惠的每GB价格购买我们的套餐之一' : 'Buy one of our packages at a more favorable price per GB',
          'purchase.dynamicResidence': lang === 'zh' ? '动态住宅' : 'Dynamic Residence',
          'purchase.staticResidence': lang === 'zh' ? '静态住宅' : 'Static Residence',
          'purchase.discountPrice': lang === 'zh' ? '折扣价' : 'Discount Price',
          'purchase.pleaseSelectPackage': lang === 'zh' ? '请选择套餐' : 'Please select a package',
          'purchase.confirm': lang === 'zh' ? '确认' : 'Confirm',
          'purchase.cancel': lang === 'zh' ? '取消' : 'Cancel',
          'purchase.loginWarning': lang === 'zh' ? '请重新登录！' : 'Please login again!',
          'purchase.accountInfo': lang === 'zh' ? '账户信息' : 'Account Information',
          'purchase.noPlan': lang === 'zh' ? '无' : 'None',
          'purchase.selectPackage': lang === 'zh' ? '选择套餐' : 'Select Package'
        };
        return translations[key] || key;
      },
      //获取支付按钮名称
      getBtnnameList() {
      this.$request.get('/package/getpassagewaytype?uid=' + this.uid).then((res) => {
        if (res.data.code === 200) {
              console.log(res.data.data);
              this.BtnnameList = res.data.data;
          }
          })
          .catch((e) => {
          console.log(e);
          })
          .finally(() => {
          });
      },

      changeTab(){
        //每次切换tab,重新设置pid
        if(this.value == 'dtzz' ){
            if(Array.isArray(this.broadList) && this.broadList.length >0){
              this.Mkprice = this.broadList[0].unitPrice
              this.pid = this.broadList[0].pid;
              this.selectlevelValue = this.broadList[0].pid;
            }else{
              this.Mkprice = 0
              this.pid = 0;
              this.selectlevelValue = null;
            }
        }
        else if(this.value == 'jtzz' ){
            if(Array.isArray(this.broadListj) && this.broadListj.length >0){
              this.Mkprice = this.broadListj[0].unitPrice
              this.pid = this.broadListj[0].pid;
              this.selectleveljValue = this.broadListj[0].pid;
            }else{
              this.Mkprice = 0
              this.pid = 0;
              this.selectleveljValue = null;
            }
        }
        console.log('切换选项卡后，pid:', this.pid);
      },

      //获取下拉框pid
      changepid(e){
          this.pid = e;
          console.log(this.pid);
      },

      //获取支付订单页面
      getorder(){
          console.log(this.pid);
          this.$request.post('/order/creat',{pid:this.pid,uid:Number(this.uid),passagewayType:this.dictValueType}).then((res) => {
            if (res.data.code === 200) {
              this.payurl = res.data.data.paylink
            }
          })
          .catch((e) => {
            console.log(e);
          })
      },
      //点击按钮弹出支付通道对话框
      PaymentWays(item){
          this.dictValueType = item.dictValue;
          if(this.pid != 0){
              this.getorder();
              this.visiblepay = true;
          }
          else{
              this.$message.warning(this.translate('purchase.pleaseSelectPackage'))
          }
      },
      
      //确认支付
      addflew(){
          console.log(1);
      },
      // 倒计时
      timecalc() {
          var _this = this
          var time = window.setInterval(function () {
              if (_this.seconds === 0 && _this.minutes !== 0) {
              _this.seconds = 59
              _this.minutes -= 1
              } else if (_this.minutes === 0 && _this.seconds === 0) {
              _this.seconds = 0
              _this.timeShow = false
              window.clearInterval(time)           
              sessionStorage.setItem("timeShow",JSON.stringify('false'));
              } else {
              _this.seconds -= 1
              }
          }, 1000)
      },
      
  },
  //清空定时器
  beforeDestroy(){
      if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
      }
  },
  
};
</script>

<style scoped lang="less">
// 品牌色彩变量定义 - 暗黑主题
@primary-color: #00ea90;
@primary-hover: #33eeab;
@primary-active: #00c77a;
@success-color: #00ea90;
@warning-color: #faad14;
@error-color: #f5222d;
@text-primary: #ffffff;
@text-secondary: rgba(255, 255, 255, 0.65);
@text-tertiary: rgba(255, 255, 255, 0.45);
@border-color: rgba(255, 255, 255, 0.1);
@border-hover: rgba(255, 255, 255, 0.2);
@bg-primary: #2d2c28;
@bg-secondary: #1e1e1e;
@bg-gradient: linear-gradient(135deg, @bg-secondary 0%, @bg-primary 100%);
@card-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
@card-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.3);

.purchase-container {
  padding: 24px;
  background: transparent;
  min-height: calc(100vh - 64px);
}

// 流量统计卡片样式
.flow-card {
  background: #2d2c28 !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  color: @text-primary;
  position: relative;
  overflow: hidden;
  margin-bottom: 24px;
  border-radius: 12px;
  
  .flow-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
    
    .flow-icon {
      font-size: 32px;
      margin-right: 16px;
      color: @primary-color;
    }
    
    .flow-title {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0.5px;
      color: @text-primary;
    }
  }
  
  .flow-stats {
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
    
    .flow-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      
      .flow-label {
        font-size: 14px;
        color: @text-secondary;
        font-weight: 500;
      }
      
      .flow-value {
        font-size: 28px;
        font-weight: 700;
        letter-spacing: -0.5px;
        color: @text-primary;
      }
    }
  }
  
  :deep(.ant-divider) {
    border-color: rgba(255, 255, 255, 0.1) !important;
    margin: 12px 0 !important;
  }
  
  :deep(.ant-card-body) {
    padding: 32px !important;
  }
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4) !important;
  }
}

// 购买选择卡片
.highlight-card {
  background: #2d2c28 !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px;
  
  :deep(.ant-card-body) {
    padding: 24px;
  }
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .header-icon {
    font-size: 24px;
    color: @primary-color;
    margin-right: 16px;
  }

  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: @text-primary;
    letter-spacing: 0.5px;
  }
}

// Tabs 样式
.custom-tabs {
  :deep(.ant-tabs-nav) {
    .ant-tabs-tab {
      color: @text-secondary;
      &:hover {
        color: @primary-hover;
      }
    }
    .ant-tabs-tab-active {
      color: @primary-color;
    }
  }
  :deep(.ant-tabs-ink-bar) {
    background-color: @primary-color;
  }
}

// 章节标题
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: @text-primary;
  margin-bottom: 8px;
  margin-top: 16px;
}

// 章节描述
.section-desc {
  font-size: 14px;
  color: @text-secondary;
  margin-bottom: 24px;
  line-height: 1.6;
}

// 选择行样式
.select-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 24px;
  background: #1e1e1e;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: @card-shadow;
  }

  .select-item {
    flex: 1;
    min-width: 220px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .config-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .config-label {
    font-size: 14px;
    font-weight: 600;
    color: @text-secondary;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }
}

// 自定义选择框
.custom-select {
  width: 100%;
  padding: 0 !important;
  :deep(.ant-select) {
    width: 100%;
    
    .ant-select-selection {
      background-color: transparent !important;
      border: 1px solid rgba(255, 255, 255, 0.2) !important;
      color: @text-primary !important;
      height: 40px !important;
      border-radius: 4px !important;

      &:hover {
        border-color: @primary-color !important;
      }
    }
    
    .ant-select-selection__rendered {
      line-height: 38px;
    }
    
    .ant-select-arrow {
      color: @text-secondary;
    }
    
    .ant-select-open .ant-select-selection {
      border-color: @primary-color !important;
      box-shadow: 0 0 0 2px rgba(0, 234, 144, 0.2) !important;
    }
  }
}

// 全局下拉菜单暗色覆盖 (如果生效)
:deep(.ant-select-dropdown) {
  background-color: #2d2c28 !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  .ant-select-dropdown-menu-item {
    color: @text-secondary;
    &:hover, &-active {
      background-color: rgba(255, 255, 255, 0.08) !important;
      color: @text-primary;
    }
    &-selected {
      background-color: rgba(0, 234, 144, 0.1) !important;
      color: @primary-color !important;
    }
  }
}

// 操作按钮样式
.action-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding: 20px;
  background: #1e1e1e;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: @card-shadow;
  }
}

.action-buttons {
  gap: 12px;
}

.action-btn {
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
  background: transparent;
  color: @text-primary;
  border: 1px solid rgba(255, 255, 255, 0.2);
  
  &:hover {
    transform: translateY(-2px);
    border-color: @primary-color;
    color: @primary-color;
    background: transparent;
  }
}

.generate-btn {
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  padding: 0 32px;
  background: @primary-color !important;
  color: #000 !important;
  border: none !important;
  border-radius: 4px;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 234, 144, 0.3);
    background: @primary-hover !important;
  }
  
  &:active {
    transform: translateY(0);
  }
}

// 支付模态框
.payment-modal {
  :deep(.ant-modal-content) {
    background-color: #2d2c28;
    color: @text-primary;
  }
  :deep(.ant-modal-header) {
    background-color: #2d2c28;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 20px 24px;
    
    .ant-modal-title {
      color: @text-primary;
      font-size: 18px;
      font-weight: 600;
    }
  }
  
  :deep(.ant-modal-close-x) {
    color: @text-secondary;
    &:hover {
      color: @text-primary;
    }
  }
  
  :deep(.ant-modal-body) {
    padding: 24px;
    
    iframe {
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
  }
  
  :deep(.ant-modal-footer) {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 16px 24px;
    
    .ant-btn {
      background: transparent;
      border-color: rgba(255, 255, 255, 0.2);
      color: @text-primary;
      &:hover {
        border-color: @primary-color;
        color: @primary-color;
      }
    }
    .ant-btn-primary {
      background: @primary-color;
      border-color: @primary-color;
      color: #000;
      &:hover {
        background: @primary-hover;
        border-color: @primary-hover;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .purchase-container {
    padding: 16px;
  }
  
  .select-row {
    padding: 16px;
    gap: 16px;
    
    .select-item {
      min-width: 100%;
    }
  }
  
  .action-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px;
    
    .generate-btn,
    .action-btn {
      width: 100%;
      justify-content: center;
    }
  }
  
  .action-buttons {
    display: flex;
    width: 100%;
    gap: 12px;
    flex-wrap: wrap;
    
    .action-btn {
      flex: 1;
      min-width: 100px;
    }
  }
  
  .content-card {
    :deep(.ant-card-body) {
      padding: 20px;
    }
  }
  
  .flow-card {
    .flow-stats {
      .flow-item {
        .flow-value {
          font-size: 24px;
        }
      }
    }
  }
}
</style>